// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bdaf964c","508":"2d80b5d8","547":"ba9fc85a","703":"258afee5"}[chunkId] + ".chunk.js";
};